export const contractTabLabel: any = {
  contracts_count: 'All Contracts',
  master_contracts: 'Master Contracts',
  active: 'Active',
  expiring: 'Exp. this Month',
  expiring_this_quarter: 'Exp. this Quarter',
  expiring_next_quarter: 'Exp. next Quarter',
  expired: 'Expired',
  // total_contracts_size: 'Used Space',
  total_reminders: 'With Reminders',
  terminated: 'Terminated',
  under_renewal: 'Under Renewal',
  under_amend: 'Under Amend',
};

export const contractTabTooltip: any = {
  contracts_count: 'All Contracts',
  master_contracts: 'Master Contracts',
  active: 'Active',
  expiring: 'Expiring this Month',
  expiring_this_quarter: 'Expiring this Quarter',
  expiring_next_quarter: 'Expiring next Quarter',
  expired: 'Expired',
  // total_contracts_size: 'Used Space',
  total_reminders: 'With Reminders',
  terminated: 'Terminated Contracts',
  under_renewal: 'Renewals initiated but not yet executed',
  under_amend: 'Amendments initiated but not yet executed',
};

export const contractTableTabLabel: any = {
  all: 'All Contracts',
  // active: 'Active Contracts',
  // expired: 'Expired Contracts',
  // terminate: 'Terminated Contracts',
  my_contracts: 'My Contracts',
  all_under_renewal: 'Under Renewal',
  all_under_amend: 'Under Amendment',
  terminate: 'Under Termination',
};

export const statusFilterList = [
  { value: 'not started', name: 'Not Started' },
  { value: 'processing', name: 'Processing' },
  { value: 'done', name: 'Done' },
];

export const submissionTypes: any = {
  Amendment: 'Amendment',
  'Renewal Amendment': 'Renewal',
  'Terminated Amendment': 'Termination',
};

export const renewAmendChipValue = (docID: string) => {
  const match = docID?.match(/\(([^)]+)\)/);
  return match ? match[1] : null;
};
